var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"d-flex mt-5 mb-2 data-panel-section",attrs:{"cols":"12"}},[_c('div',{staticClass:"my-n1 py-1"},[_c('span',{staticClass:"font-weight-bold ma-2"},[_vm._v(_vm._s(_vm.label))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }